import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Box, Flex, Button } from '@elparking/components'
import PriceBlock from './PriceBlock'
import CurrencyWrapper from './CurrencyWrapper'

const SelectPriceBlock = ({ rate, flexDirection, textAlign, onClick, isMutuaUser }) => {
    return <Flex flexDirection={flexDirection} flexWrap='wrap' alignItems='center' width='100%' justifyContent='space-between'>
        <PriceBlock
          rate={rate}
          currencyWrapper={CurrencyWrapper}
          flexDirection={flexDirection}
          textAlign={textAlign}
          isMutuaUser={isMutuaUser} />
        <Box textAlign={textAlign}>
            <Button fontSize='small' height='auto' fontWeight='bold' onClick={() => onClick(rate)}>

                <FormattedMessage defaultMessage='Seleccionar' />

            </Button>
        </Box>
    </Flex>
}

SelectPriceBlock.propTypes = {
    onClick: PropTypes.func,
    flexDirection: PropTypes.string,
    textAlign: PropTypes.string,
    rate: PropTypes.shape({
        price: PropTypes.any,
        exclusive: PropTypes.bool,
        displayPrice: PropTypes.string,
    }),
    isMutuaUser: PropTypes.bool,
}

export default SelectPriceBlock
